"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));

var _player = _interopRequireDefault(require("@vimeo/player"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var PROPORTION = 1.78;

var Hero = function Hero(props) {
  var title = props.title,
      backgroundImage = props.backgroundImage,
      vimeoId = props.vimeoId,
      svgLandscape = props.svgLandscape,
      svgPortrait = props.svgPortrait,
      verticalAlignment = props.verticalAlignment,
      horizontalAlignment = props.horizontalAlignment,
      typeface = props.typeface,
      textColor = props.textColor;
  var videoContainerRef = (0, _react.useRef)(null);
  var playerRef = (0, _react.useRef)(null);

  var initVideo = function initVideo() {
    if (playerRef.current) {
      playerRef.current.destroy();
    }

    var windowProportion = window.innerWidth / window.innerHeight;
    var vp = PROPORTION;

    var _w, _h;

    if (windowProportion > vp) {
      _w = window.innerWidth;
      _h = _w / PROPORTION;
    } else {
      _h = window.innerHeight;
      _w = _h * PROPORTION;
    }

    playerRef.current = new _player.default(videoContainerRef.current, {
      id: vimeoId,
      controls: false,
      autoplay: true,
      loop: true,
      width: _w,
      height: _h,
      muted: true,
      autopause: false
    });
    playerRef.current.on('play', function () {
      console.log('play');
    });
  };

  var initVideoDebounced = (0, _lodash.debounce)(initVideo, 200);
  (0, _react.useEffect)(function () {
    if (vimeoId) {
      initVideo();
      window.addEventListener('resize', initVideoDebounced);
      return function () {
        window.removeEventListener('resize', initVideoDebounced);
      };
    }
  }, []);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.BackgroundContainer, {
    ref: videoContainerRef,
    backgroundImage: backgroundImage
  }), _react.default.createElement(_styles.InnerContainer, {
    verticalAlignment: verticalAlignment,
    horizontalAlignment: horizontalAlignment
  }, (svgLandscape || svgPortrait) && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.ImgPortrait, {
    src: svgPortrait || svgLandscape,
    alt: svgPortrait
  }), _react.default.createElement(_styles.ImgLandscape, {
    src: svgLandscape || svgPortrait,
    alt: svgLandscape
  })), !svgPortrait && !svgLandscape && title && _react.default.createElement(_styles.Title, {
    typeface: typeface || 'black',
    color: textColor
  }, title))));
};

exports.Hero = Hero;